export  class CustomEvalLevelsVM{

    public Id:number;
    public LevelName:string;
}

export enum UserAccessType {
    GlobalAdministrator = 1,
    DealershipAdministrator = 2,
    DealershipUser = 3,
    CustomerAdministrator = 4,
    CustomerUser = 5
}

export class FilteredListVm {
    Id:number;
    Name:string;
    LevelId:number;
    customerId:number;
}

export class ApplyToAllCompsVm{
    A:number;
    B:number;
    C:number;
    LevelId:number;
    Value:number;
}

export class DeleteEquipemntRangeVM{
    public equipments:EquipmentRanges[];
}

export class EquipmentRanges{
    public equipmentId:number;
    public level:number;
}
export class ApplyToAllCompsEquipmentsVm{
    A:number;
    B:number;
    C:number;
    LevelId:number;
    Value:number[];
}
export class CustomeEvaluationRangeVM{
            public  Id :number
            public  LinkA :number
            public  LinkB :number
            public  LinkC :number

            public  BushA :number
            public  BushB :number
            public  BushC:number

            public  ShoeA :number
            public  ShoeB :number
            public  ShoeC :number


            public  IdlerA :number
            public  IdlerB :number
            public  IdlerC :number

            public  SprocketA :number
            public  SprocketB :number
            public  SprocketC :number

            public  TrackRollerA:number
            public  TrackRollerB :number
            public  TrackRollerC :number

            public  CarrierRollerA :number
            public  CarrierRollerB :number
            public  CarrierRollerC :number

            public  RSRearIdlerA :number
            public  RSRearIdlerB :number
            public  RSRearIdlerC :number

            public  CrawlerGuideA :number
            public  CrawlerGuideB :number
            public  CrawlerGuideC :number

            public  ElongationA :number
            public  ElongationB :number
            public  ElongationC :number

            public  GeneralA :number
            public  GeneralB :number
            public  GeneralC :number

           public  IsDefault :boolean

           public LevelId:number;
           public SelectedValue:number;
           public SelectedValueList:number[];
 
}

export class EquipmentForSelectionVM{
    public EquipmentId:number;
    public Dealer:string;
    public Customer:string;
    public JobSite:string;
    public SerialNo:string;
    public UnitNo:string;
    public Make:string;
    public Model:string;
    public Family:string;
    public Level:string;
    public LevelId:number;
    public select:boolean=false;
    public isDeleted:boolean=false;
}

export class WSreStatusModel {
    StatusId:number;
    StatusName:string;
    
}

export class WSreFrameChainStatusModel {
    LeftSideStatus:number;
    RightSideStatus:number;
    
}
export class UpdateJobDetailsRequest {
    wsreId  : number;
    jobNumber: string; 
    customerReference: string; 
    oldJobNumber: string;
    serialNumber: string;
    serialNumberRight?: string;
    JobsiteId?: number;
    ScreenId?: number;
  }